document.addEventListener('DOMContentLoaded', function () {
  const tables = document.querySelectorAll('.mhecomm-table .table');
  if (!tables || tables.length === 0) {
    return;
  }

  applyFocusOnTable(tables);

  let resizeTimeout;
  function handleResizeChange() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      applyFocusOnTable(tables);
    }, 500);
  }
  window.removeEventListener('resize', handleResizeChange);
  window.addEventListener('resize', handleResizeChange);
});

function applyFocusOnTable(tables) {
  const tableArray = Array.from(tables);

  if (atLeastOneHasHorizontalScroll(tableArray)) {
    tableArray.forEach((table) => table.setAttribute('tabindex', '0'));
  } else {
    tableArray.forEach((table) => table.removeAttribute('tabindex'));
  }
}
/*
Check if at least one table loaded in the page has horizontal scroll
*/
function atLeastOneHasHorizontalScroll(tableArray) {
  return tableArray.some((table) => {
    const tableWrapper = table.parentElement;
    return tableWrapper && tableWrapper.scrollWidth > tableWrapper.clientWidth;
  });
}
